// extracted by mini-css-extract-plugin
module.exports = {"despositAmountModal":"_1aQASQXYl9lfBigeHNM14o"};